<!-- 메인 -->
<template>
    <div class="mainBody">
<!--      <emarticon-barcode v-if="showBarcode" :barcodeInfo="barcodeInfo" @toggleBarcodePopup="toggleBarcodePopup"></emarticon-barcode>-->
<!--      <emarticon-card :slide-data="cardList" v-on:toggleBarcodePopup="toggleBarcodePopup" classname="home-slide"></emarticon-card>-->
<!--      <button-box></button-box>-->
      <div class="card-button-box">
        <div>
          <span></span>
          <button>{{merchantName}}</button>
        </div>
        <div></div>
        <div>
          <span class="icon-board"></span>
          <button @click="$router.push({name:'awardDetail'})">시상 내역</button>
        </div>
      </div>
<!--      <banner data="banner_emart"></banner>-->
      <emarticon-award-list :goods-list="goodsList" :total-rows="goodsTotalRows" @getPrepaidCardGoods="getPrepaidCardGoods"></emarticon-award-list>
<!--      <use-box></use-box>-->
      <alert-popup v-if="showAlertPopup === true" @confirmPopupClickConfirm="showAlertPopup = false" :message="alertMessage"></alert-popup>
    </div>
</template>
<script>
  // import EmarticonCard from '@/components/common/EmarticonCard.vue';
  // import ButtonBox from '@/components/common/ButtonBox.vue';
  // import GrayLine from '@/components/common/GrayLine.vue';
  // import UseBox from '@/components/common/UseBox.vue';
  // import EmarticonList from '@/components/list/EmarticonList.vue';
  // import EmarticonBarcode from '@/views/home/emarticonBarcode.vue';
  import apiList from "@/api/apiList";
  import AlertPopup from "@/views/myemarticon/alertPopup";
  import emarticonAwardList from "@/views/award/emarticonAwardList";
  // import Banner from'@/components/common/Banner.vue';

export default {
  name: "emarticonAwardHome",
  components: { emarticonAwardList, AlertPopup},
  data() {
    return {
      cardList: [],
      prepaidCardGoodsRequest: {
        orderCriteria: null,
        // size: '10',
        // pageNo: '1',
      },
      goodsList: [],
      goodsTotalRows: 0,
      prepaidCardBoxRequest: {
        orderCriteria: null,
        size: '10',
        pageNo: '1',
      },
      showBarcode: false,
      barcodeInfo: null,
      /** @type {Boolean} 경고창 팝업 show 여부*/
      showAlertPopup: false,
      /** @type {String} 경고창 팝업 메시지 */
      alertMessage: '',
      merchantName: ''
    }
  },
  created(){

    // let successNetfunnel = this.afterNetfunnel();
    //
    // NetFunnel_Action({action_id:'econ_main', skin_id: 'emart'}, {
    //   success: function(ev,ret) {
    //
    //     successNetfunnel;
    //     NetFunnel_Complete();
    //   }
    // });

    // 회원 카드 조회
    if(this.$store.state.mberInfo.mberNo){
      this.getPrepaidCardBox();
      this.getMerchantName();
    }
    this.getPrepaidCardGoods('GOODS_AMOUNT_DESC');

    if(this.$route.query.code && this.$route.query.message){
      this.alertMessage = decodeURI(this.$route.query.message);
      this.showAlertPopup = true;
      this.$router.replace({'query': null});
    }
  },
  destroyed() {
    window.popStateDetected = false
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  mounted() {
  },
  beforeUpdate() {
    this.$heading('이마티콘');
  },
  methods: {
    // preventBack: function() {
    //   window.location.href = "emart-today://goback/?enable=Y"  // 뒤로가기 허용
    // },
    /**
     * 카드 보관함 호출
     */
    async getPrepaidCardBox() {
      try {
        const res = await apiList.getPrePaidCardBox(this.prepaidCardBoxRequest);
        this.cardList = res.data.data.list;
      } catch (error) {
        console.error(error);
      }
    },
    afterNetfunnel(){

      // 회원 카드 조회
      if(this.$store.state.mberInfo.mberNo){
        this.getPrepaidCardBox();
      }
      this.getPrepaidCardGoods('GOODS_AMOUNT_DESC');

      if(this.$route.query.code && this.$route.query.message){
        this.alertMessage = decodeURI(this.$route.query.message);
        this.showAlertPopup = true;
        this.$router.replace({'query': null});
      }
    },
    /**
     * 상품 페이지 조회 호출
     */
    async getPrepaidCardGoods(orderCriteria) {
      try {
        if(orderCriteria !== null && orderCriteria !== '') {
          this.prepaidCardGoodsRequest.orderCriteria = orderCriteria;
        }
        const res = await apiList.getPrepaidCardB2BGoodsList(this.prepaidCardGoodsRequest);
        this.goodsList = res.data.data;
        this.goodsTotalRows = res.data.data.totalRows;
      } catch (error) {
        console.error(error);
      }
    },
    toggleBarcodePopup(barcodeInfo) {
      this.showBarcode = !this.showBarcode;
      if(this.showBarcode) {
        this.barcodeInfo = barcodeInfo;
      }
    },
    /**
     * loginModal 값 변경 메소드
     * @param {boolean} loginModalFlag loginModal 플래그 값
     */
    updateloginModal(loginModalFlag){
      this.loginModal = loginModalFlag;
      const bodyHtml = document.body
      if(this.loginModal === true){
        // 로그인 필요 팝업이 뜨면 스크롤 막기
        bodyHtml.style.overflow = 'hidden'
      } else {
        // 로그인 필요 팝업이 닫히면 스크롤 막기 해제
        bodyHtml.style.overflow = 'auto'
      }
    },
    async getMerchantName() {
      try {

        const merchantCode = this.$store.state.mberInfo.mberNo.substring(0,4);

        const param = {
          ctmmnyNo : this.$store.state.mberInfo.ctmmnyNo,
          langTyCode: this.$store.state.langTyCode,
          groupCode: "EMT0001",
          codeValue: merchantCode
        }

        const response = await apiList.getCommonCode(param);

        if (response.data.code === 'S00000') {
          //가맹점명 가져오기
          this.merchantName = response.data.data[0].codeNm;
          this.$store.state.merchantName = this.merchantName;
        }
      } catch (error) {
        //공통코드 검증 실패
      }
    }


  }
}
</script>

<style lang="scss">
  @import '@/assets/styles/common/buttonBox.scss';
  @import '@/assets/styles/common/useBox.scss';
</style>
